import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-prev-next',
  templateUrl: './prev-next.component.html',
  styleUrl: './prev-next.component.scss',
  standalone: false
})
export class PrevNextComponent {
  @Input({ required: true }) type!: 'prev' | 'next';
}
